import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";
import {
  ref,
} from "vue";
import type {
  WebchargeSettings,
} from "@/components/settings/scripts/Webcharge";
import {
  HelperFunctions,
} from "@/scripts/Common/HelperFunctions";
import {
  Constants,
} from "@/scripts/Common/Constants";
import {getToken} from "@/scripts/Common";

const webchargeSettings = ref<WebchargeSettings>({
  hasSpecificChargingDays: false,
  chargingDays: [],
});

const responseError = ref<any>();

const loadConfiguredWebcharges = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'webchargeConfiguration',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
    }
  });

  webchargeSettings.value = response;
  responseError.value = error;
}

const getEnabledDates = (val: Date) => {
  const day = val.getDate();
  const month = val.getMonth() + 1;
  const year = val.getFullYear();

  if (!webchargeSettings.value.hasSpecificChargingDays) {
    return true;
  }

  return webchargeSettings.value.chargingDays?.includes(day.toString())
    || (webchargeSettings.value.chargingDays?.includes(Constants.ULTIMO) &&
      HelperFunctions.getLastDayOfMonth(year, month) === day);
}

const useWebchargeSettings = () => {

  loadConfiguredWebcharges();

  return {
    webchargeSettings,
    error: responseError,
    getEnabledDates
  }
}



export {
  useWebchargeSettings
}

